import { footerByDocIdDomainSelector, makeNullSafeDomainGetter, createIsLoadingSelector } from './common';
import { createSelector } from 'reselect';

const footerByDocIdSelector = makeNullSafeDomainGetter(footerByDocIdDomainSelector, 'footerByDocId');
export const isFooterByDocIdLoadingSelector = createIsLoadingSelector(footerByDocIdDomainSelector);

export const cityFooterSelector = createSelector(footerByDocIdSelector, data => data && data.rows.length ? data : null);
